import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { RootState, Dispatch } from "../../../store/types";
import { Color } from "../../../components";
import { Product, Color as ColorModel, ProductLayout } from "../../../models";
import { SummaryState } from "../reducer";
import * as selectors from "../selectors";
import * as actions from "../actions";
import { selectors as step1Selectors } from "../../Step1";
import { selectors as layoutSelectors } from "../../WizardLayoutChoice";
import { selectors as colorSelectors } from "../../WizardColorChoice";
import { selectors as suppFormSelectors } from "../../Step5";
import Summary, { SummaryProps } from "./Summary";

export interface SummaryContainerProps extends SummaryState, SummaryProps {
  costString: string;
  timeString: string;
  chosenStyles: string[];
  chosenColor?: ColorModel;
  chosenProduct?: Product;
  chosenLayout?: ProductLayout;
  fetchEstimateData: () => void;
}

interface SummaryContainerState {
  updatingTime: boolean;
  updatingCost: boolean;
}

class SummaryContainer extends React.Component<
  SummaryContainerProps,
  SummaryContainerState
> {
  public state: SummaryContainerState = {
    updatingCost: false,
    updatingTime: false,
  };

  public componentDidMount() {
    if (!this.props.costPolicy && this.props.chosenProduct) {
      this.props.fetchEstimateData();
    }
  }

  public componentDidUpdate(prevProps: SummaryContainerProps) {
    if (prevProps.costString !== this.props.costString) {
      this.toggleAnimation("updatingCost");
      setTimeout(() => this.toggleAnimation("updatingCost"), 500);
    }
    if (prevProps.timeString !== this.props.timeString) {
      this.toggleAnimation("updatingTime");
      setTimeout(() => this.toggleAnimation("updatingTime"), 500);
    }
  }

  private toggleAnimation = (stateKey: "updatingCost" | "updatingTime") =>
    this.setState(state => ({ ...state, [stateKey]: !state[stateKey] }));

  private renderCalc = (
    stateKey: "updatingCost" | "updatingTime",
    propKey: "costString" | "timeString",
  ) => () =>
    this.state[stateKey] ? (
      <i className="fa fa-fw fa-pulse fa-spinner" />
    ) : (
      this.props[propKey]
    );

  private renderCost = this.renderCalc("updatingCost", "costString");
  private renderTime = this.renderCalc("updatingTime", "timeString");

  private renderStyles = () =>
    this.props.chosenStyles.length ? (
      this.props.chosenStyles.join(", ")
    ) : (
      <Link to="/wizard/step-3">Chưa chọn</Link>
    );

  private renderColor = () =>
    this.props.chosenColor ? (
      <Color mini {...this.props.chosenColor} />
    ) : (
      <Link to="/wizard/step-4">Chưa chọn</Link>
    );

  private renderLayout = () =>
    this.props.chosenLayout ? (
      this.props.chosenLayout.name
    ) : (
      <Link to="/wizard/step-2">Chưa chọn</Link>
    );

  public render() {
    return (
      <Summary
        {...this.props}
        cost={this.renderCost()}
        time={this.renderTime()}
        styles={this.renderStyles()}
        color={this.renderColor()}
        layout={this.renderLayout()}
        layoutImg={this.props.chosenLayout && this.props.chosenLayout.image}
      />
    );
  }
}

const mapStateToProps = (state: RootState): Partial<SummaryContainerProps> => ({
  chosenProduct: step1Selectors.chosenProduct(state),
  productName: selectors.productName(state),
  chosenStyles: selectors.chosenStyles(state),
  chosenLayout: layoutSelectors.chosenLayout(state),
  costPolicy: selectors.costPolicy(state),
  chosenColor: colorSelectors.chosenColor(state),
  costString: selectors.cost(state),
  timeString: selectors.time(state),
  sampleNumber: selectors.sampleNumber(state),
  isTOCChecked: selectors.isTOCChecked(state),
  submitError: suppFormSelectors.submitError(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<SummaryContainerProps> => ({
  toggleTOCAgreement: () => dispatch(actions.toggleTOCAgreement()),
  fetchEstimateData: () => dispatch(actions.fetchEstimateData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SummaryContainer);



// WEBPACK FOOTER //
// ./src/routes/WizardSummary/components/SummaryContainer.tsx